module.exports = __webpack_public_path__ + "56341d353983b0de057964ec52674622.svg";